import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';

import Carousel from '../../darkmatter/Carousel';
import IndicatorGroup from './components/IndicatorGroup';
import Event from '../../darkmatter/Event';
import { GatsbyImagePropType } from '../../services/proptypes';
import Image from '../../atoms/Image';
import './ImageBanner.css';

export default class ImageBanner extends React.Component {
  getOverlayClassNames() {
    const { overlay } = this.props;

    if (overlay === 'primary') return 'overlay-primary';
    if (overlay === 'dark') return 'overlay-dark';
    if (overlay === 'light') return 'overlay-light';

    return '';
  }

  renderImage(image, indicatorGroup = null) {
    const { backgroundSize, height, header, tagline, callToAction, parallax } = this.props;

    const imageStyle = {
      backgroundAttachment: parallax && 'fixed',
      backgroundSize,
      height,
    };

    const overlayStyle = {
      width: '100%',
      height: '100%',
    };

    const overlayClassNames = this.getOverlayClassNames();

    return (
      <Image className="image-banner" background imageQuery={image} src={image} style={imageStyle}>
        <Grid
          className={`image-banner-animation ${overlayClassNames}`}
          style={overlayStyle}
          verticalAlign="middle"
          textAlign="center"
        >
          <Grid.Column>
            {header}
            {tagline}
            {callToAction && (
              <Event
                event={{ category: 'Image Banner', action: 'Click', label: 'call to action' }}
                eventType="click"
              >
                {callToAction}
              </Event>
            )}
            {indicatorGroup}
          </Grid.Column>
        </Grid>
      </Image>
    );
  }

  renderBanner() {
    const { backgroundImage } = this.props;

    return this.renderImage(backgroundImage);
  }

  renderGallery() {
    const { galleryImages, carouselOptions } = this.props;

    const { autoScroll, autoScrollTime } = carouselOptions;

    const indicatorStyle = {
      textAlign: 'center',
      position: 'absolute',
      bottom: '1em',
      left: 0,
      right: 0,
      marginLeft: 'auto',
      marginRight: 'auto',
      width: 200,
    };

    return (
      <Carousel
        totalNumberOfItems={galleryImages.length}
        autoScroll={autoScroll}
        autoScrollTime={autoScrollTime}
        numberOfDisplayItems={1}
      >
        {({ currentIndex, changeCurrentIndex }) => (
          <div style={{ position: 'relative' }}>
            {this.renderImage(galleryImages[currentIndex])}
            <div style={indicatorStyle}>
              <IndicatorGroup
                images={galleryImages}
                currentIndex={currentIndex}
                changeCurrentIndex={changeCurrentIndex}
                event={{
                  category: 'Image-Banner',
                  action: 'Click',
                  label: 'Carousel-Indicator',
                }}
              />
            </div>
          </div>
        )}
      </Carousel>
    );
  }

  render() {
    const { as } = this.props;
    return as === 'banner' ? this.renderBanner() : this.renderGallery();
  }
}

ImageBanner.propTypes = {
  as: PropTypes.oneOf(['banner', 'carousel']),
  backgroundImage: PropTypes.oneOfType([PropTypes.string, GatsbyImagePropType]),
  backgroundSize: PropTypes.oneOf(['cover', 'contain']),
  callToAction: PropTypes.element,
  carouselOptions: PropTypes.shape({
    autoScroll: PropTypes.bool,
    autoScrollTime: PropTypes.number,
  }),
  galleryImages: PropTypes.oneOf(
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.arrayOf(GatsbyImagePropType),
  ),
  header: PropTypes.element,
  height: PropTypes.number,
  overlay: PropTypes.oneOf(['dark', 'light', 'primary', 'none']),
  parallax: PropTypes.bool,
  tagline: PropTypes.element,
};

ImageBanner.defaultProps = {
  as: 'banner',
  backgroundImage: '',
  backgroundSize: 'cover',
  callToAction: null,
  carouselOptions: {
    autoScroll: undefined,
    autoScrollTime: undefined,
  },
  galleryImages: [],
  header: null,
  height: 500,
  overlay: 'none',
  parallax: false,
  tagline: null,
};
